<template>
  <div class="row">
    <div class="col col-md-12">
      <div
        class="row"
        style="zoom: 1; margin-bottom: 20px"
        v-if="retornaSite() == 'Bll'"
      >
        <div class="col-md-12 text-center">
          <span>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              style="zoom: 1; margin-top: 10px"
              @click="carregarItens()"
            >
              Atualizar
            </button>
          </span>
        </div>
      </div>

      <div class="rowLista" style="margin-top: 10px">
        <div class="list-group-item list-group-item-dark text-left">
          <div class="row">
            <div
              class="col d-none d-sm-block"
              v-if="retornaSite() !== 'Share'"
              style="max-width: 100px"
            >
              <h5 style="margin-top: 9px" class="text-center">Hora</h5>
            </div>
            <div class="col">
              <h5 style="margin-top: 9px">
                {{ retornaSite() == "Bll" ? "Jogo" : "Evento" }}
              </h5>
            </div>
          </div>
        </div>

        <div
          class="list-group-item text-left"
          v-for="item in itens"
          :key="item.id"
          :item="item"
        >
          <div class="row">
            <div
              class="col text-center align-middle"
              style="
                padding-top: 0px;
                padding-bottom: 0px;
                max-width: 90px;
                min-width: 90px;
              "
              v-if="retornaSite() !== 'Share'"
            >
              <div>
                <small> {{ formatarHora(item) }}</small>
              </div>
              <div v-if="item.situacao == 3" class="text-danger">
                <small>Ao Vivo</small>
              </div>
            </div>
            <div
              class="col d-flex align-self-center"
              style="padding-top: 0px; padding-bottom: 0px"
            >
              <div class="">
                <h6
                  v-if="item.competicao && item.competicao !== ''"
                  class="text-primary"
                  style="margin-bottom: 2px"
                >
                  <small
                    ><strong>{{ item.competicao }}</strong></small
                  >
                </h6>
                <div>{{ item.nome }}</div>
              </div>
            </div>
            <div
              class="col-2 d-flex align-self-center justify-content-end"
              style="padding-top: 0px; padding-bottom: 0px"
            >
              <div
                style="margin-top: 0px"
                v-if="
                  item.situacao == 3 ||
                  retornaTipoUsuario() == 'Administrador' ||
                  retornaTipoUsuario() == 'Apresentador'
                "
              >
                <button
                  v-if="retornaSite() !== 'Share'"
                  type="button"
                  @click="abrirEvento(item, false)"
                  class="btn btn-sm btn-success mb-2 mb-md-0 mr-0 mr-md-2"
                  style="font-size: 8px"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Com radar"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-bar-chart-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"
                    ></path>
                  </svg>
                </button>
                <button
                  v-if="retornaSite() !== 'Share'"
                  type="button"
                  @click="abrirEvento(item, true)"
                  class="btn btn-sm btn-success"
                  style="font-size: 8px"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Sem radar"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-easel"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0zM2 3v7h12V3H2z"
                    ></path>
                  </svg>
                </button>
                <button
                  v-if="retornaSite() == 'Share'"
                  type="button"
                  @click="abrirEvento(item, true)"
                  class="btn btn-sm btn-success"
                  style="font-size: 10px"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View"
                >
                  <span>View</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <h1 class="tituloJogos" v-if="retornaSite() !== 'Share'">Encerrados</h1>

        <p
          v-if="itensEncerrados.length == 0 && retornaSite() !== 'Share'"
          style="margin-bottom: 0px"
        >
          ------
        </p>

        <div
          class="list-group-item text-left"
          v-for="item in itensEncerrados"
          :key="item.id"
          :item="item"
        >
          <div class="row">
            <div
              class="col-2 text-center align-middle"
              style="
                padding-top: 0px;
                padding-bottom: 0px;
                max-width: 90px;
                min-width: 90px;
              "
              v-if="retornaSite() !== 'Share'"
            >
              <div v-if="item.situacao !== 3">
                <small
                  >{{ item.dataHora.toString().padStart(2, "0") }}:{{
                    item.dataMinuto.toString().padStart(2, "0")
                  }}</small
                >
              </div>
            </div>
            <div
              class="col d-flex align-self-center"
              style="padding-top: 0px; padding-bottom: 0px"
            >
              <div class="">
                <h6
                  v-if="item.competicao && item.competicao !== ''"
                  class="text-primary"
                  style="margin-bottom: 2px"
                >
                  <small
                    ><strong>{{ item.competicao }}</strong></small
                  >
                </h6>
                <div>{{ item.nome }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

export default {
  name: "ListEventosHome2",
  components: {},
  props: {
    itensLimit: { type: Number, default: 300 },
    aovivo: { type: Boolean, default: false },
    propSite: { type: String, default: "" },
    gmt: { type: Number, default: -3 },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao.usuario.tipoUsuario;
    },
    usuarioAdministrador() {
      return (
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Administrador Site"
      );
    },
    formatarHora(evento) {
      var hora = evento.dataHora.toString().padStart(2, "0");
      var minuto = evento.dataMinuto.toString().padStart(2, "0");

      try {
        var data = new Date();
        data.setHours(evento.dataHora + 3 + this.gmt);
        data.setMinutes(evento.dataMinuto);

        hora = data.getHours();
        minuto = data.getMinutes();
      } catch (err) {
        console.log(err);
      }

      return (
        hora.toString().padStart(2, "0") +
        ":" +
        minuto.toString().padStart(2, "0")
      );
    },
    async carregarItens() {
      var filtros = "";

      filtros += "?_limit=" + this.itensLimit;

      //* Verifica se foi especificado o site
      if (this.propSite !== "") {
        filtros = filtros + "&site=" + this.propSite;
      }

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      if (Object.keys(response.data).includes("gmt")) {
        this.gmt = response.data.gmt;
      }

      var arrEventos = [];
      var arrEventosPrevisto = [];
      var arrEventosEncerrados = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];

        var inserir = false;

        if (this.propSite !== "") {
          if (item.site == this.propSite) {
            inserir = true;
          }
        } else {
          if (item.site !== "Extra") {
            inserir = true;
          }
        }

        if (inserir) {
          if (item.situacao == 4) {
            arrEventosEncerrados.push(item);
          } else {
            if (item.situacao === 3) {
              arrEventos.push(item);
            } else if (item.situacao === 1) {
              arrEventosPrevisto.push(item);
            }
          }
        }
      }

      this.itens = arrEventos.concat(arrEventosPrevisto);
      this.itensEncerrados = arrEventosEncerrados;
    },
    abrirEvento(item, limpo) {
      var url = "/view/" + item._id;

      if (limpo) {
        url = url + "?view=clean";
      }

      if (
        item.situacao == 3 ||
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Apresentador"
      ) {
        window.open(
          url,
          "newwindow_" + Date.now(),
          "scrollbars=1,width=450,height=690",
          true
        );
      }
    },
  },
  mounted() {
    this.carregarItens();
  },
  data: function () {
    return {
      itens: [],
      itensEncerrados: [],
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
